import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  Location,
  NavigateFunction
} from "react-router-dom";

export interface RouterProps {
  location: Location;
  navigate: NavigateFunction;
  params: Record<string, string | undefined>;
}

export function withRouter<P extends { router: RouterProps }>(
  Component: React.ComponentType<P>
) {
  return function ComponentWithRouterProp(props: Omit<P, "router">) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        location={location}
        navigate={navigate}
        params={params}
        {...(props as P)}
      />
    );
  };
}
